<template>
	<div class="index">
		<van-nav-bar
			left-text="返回"
			left-arrow
			@click-left="back"
		/>
		<div v-if="!first">
			<div class="header-tool">
				<h3 class="title">共{{ count }}个客户</h3>
				<span @click="toggleAll" v-if="result.length == customerList.length" class="clickable select-all">取消</span>
				<span v-else @click="checkAll" class="clickable select-all">全选</span>
			</div>
			<div class="content" style="padding-bottom: var(--base-px-60)">
				<van-checkbox-group icon-size="15px" v-model="result" ref="checkboxGroup">
					<!--        <van-list-->
					<!--            v-model="loading"-->
					<!--            :finished="finished"-->
					<!--            finished-text="没有更多了"-->
					<!--            @load="onLoad"-->
					<!--        >-->
					<div class="user-list" style=""
					     v-for="(item,index) in customerList" :key="index">
						<p class="time">{{ item.createTime }}</p>
						<div class="user-item" :class="{ 'border-color' : result.indexOf(item) >= 0 }">
							<div class="top-wrapper">
								<img class="avatar clickable" :src="item.avatar"> <span class="name">{{ item.name }}</span>
								<van-checkbox @click="ac" style="position: absolute;right: var(--base-px-14);top: var(--base-px-14);"
								              :name="item">

								</van-checkbox>
							</div>
							<div class="bottom">
								<div :class="{unset: item.zk}" class="bottom-list">
									<div v-for="(i,is) in item.tags" :key="is">{{ i }}</div>
								</div>
								<div class="button" v-if="item.aa.join('').length > 18" style="padding: 0 var(--base-px-12);">
									<div v-if="!item.zk" @click="item.zk = true">
										展开
										<van-icon name="arrow-down"/>
									</div>
									<div v-else @click="item.zk = false">
										收起
										<van-icon name="arrow-up"/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--        </van-list>-->
				</van-checkbox-group>
			</div>

			<van-button :disabled="result.length < 1" class="nexts" @click="nextF" block type="info">下一步</van-button>
		</div>
		<div v-else>
			<div class="header-tool">
				<h3 class="title">批量设置群聊名称</h3>
			</div>
			<van-cell-group>
				<van-field v-model="groupName" label="群名称" placeholder="请输入群名称"/>
				<van-cell title="群序号" value="内容" label="群聊名称将按照序号依次创建">
					<van-stepper v-model="groupNum"/>
				</van-cell>

				<van-button class="nexts" :loading="loading" @click="pullRoomBtn" block type="info">开始拉群</van-button>
			</van-cell-group>
		</div>
	</div>
</template>

<script>
import {filterContact} from '../../api/roomTemplate'
import {openEnterpriseChat} from '../../utils/wxCodeAuth'
import {userCenter} from "../../api/homePage";

export default {
	data() {
		return {
			// 條件數據
			customerList: [],
			result: [],
			allChose: false,
			borderColor: {
				border: '1px solid #1890ff;'
			},
			serchData: null,
			count: 0,
			first: false,
			groupName: '',
			groupNum: 0,
			loading: false
		}
	},
	watch: {},
	methods: {
		// 客戶選擇
		ac() {
		},
		checkAll() {
			this.$refs.checkboxGroup.toggleAll(true);
		},
		toggleAll() {
			this.$refs.checkboxGroup.toggleAll();
		},
		async pullRoomBtn() {
			if (!this.groupName) {
				this.$message.error('请输入群名称')
				return
			}
			let externalUserIds = this.result.map(i => {
				return i.wxExternalUserid
			}).join(';')
			userCenter().then(async (res) => {
				let baseInfo = res.data.baseInfo
				this.loading = true
				await openEnterpriseChat(baseInfo.wxUserId, externalUserIds, this.groupName, '')
				this.loading = false
				this.$router.push('/tool/index')
			})
		},
		nextF() {
			this.first = true
		},
		back() {
			this.$router.back()
		},

		getData() {
			filterContact(this.serchData).then(res => {
				this.count = res.data.count
				res.data.list.forEach(i => {
					i.zk = false
					i.aa = i.tags
				})
				this.customerList = res.data.list
			})
		},
	},
	created() {
		if (this.$route.query.tags) {
			this.serchData = this.$route.query
			this.getData()
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar__content {
	background: #2b63cd;
	color: #fff;
}

/deep/ .van-nav-bar .van-icon {
	color: #fff;
}

/deep/ .van-nav-bar__text {
	color: #fff;
}

/deep/ .van-nav-bar__title {
	color: #fff;
}

/deep/ .van-tabs__line {
	bottom: var(--base-px-9);
	margin-top: 0;
}

/deep/ .van-tabs__nav--line {
	padding-bottom: var(--base-px-1);
}

/deep/ .van-tab__text {
	margin-bottom: var(--base-px-10);
}

/deep/ .van-tab {
	background: #ffffff;
}

/deep/ .van-tabs__nav {
	background: #F1f2f5;
}

/deep/ .van-empty__image img {
	object-fit: contain;
}

/deep/ .van-dropdown-menu__bar {
	height: var(--base-px-36);
}

/deep/ .van-ellipsis {
	font-size: var(--base-px-13);
}

/deep/ .van-action-sheet__description {
	font-size: var(--base-px-16);
	color: #444;
}

/deep/ .tabs .van-cell__title {
	width: var(--base-px-56) !important;
	flex: none !important;
	white-space: nowrap;
}

.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #f2f4f8;

	p {
		margin: 0 !important;
	}

	.fs17 {
		font-size: var(--base-px-14);
	}

	.fs13 {
		font-size: var(--base-px-12);
	}

	.fs14 {
		font-size: var(--base-px-14);
	}

	.header-tool {
		padding: 0 var(--base-px-18);
		height: var(--base-px-40);
		display: flex;
		-webkit-box-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		align-items: center;
		background-color: #fff;

		.clickable {
			font-size: var(--base-px-12);
		}

		.title {
			font-size: var(--base-px-14);
			margin: 0 !important;
		}

		.select-all {
			font-size: var(--base-px-12);
			color: #1890ff;
		}
	}

	.bottom {
		.bottom-list {
			background: #fff;
			padding: 0 var(--base-px-5);
			font-size: var(--base-px-12);
			max-height: var(--base-px-30);
			overflow: hidden;
			padding-bottom: var(--base-px-10);

			div {
				background: #f7f7f7;
				border: var(--base-px-1) solid #e9e9e9;
				display: inline-block;
				padding: var(--base-px-2) var(--base-px-3);
				border-radius: var(--base-px-6);
				margin: 0px var(--base-px-5);
				margin-bottom: var(--base-px-7);
			}
		}

		.button {
			padding: 0px var(--base-px-12);
			background: #fff;
			padding-bottom: var(--base-px-5) !important;

			div {
				font-size: var(--base-px-13);
				color: #8db1db;
			}
		}

		.unset {
			max-height: unset;
		}
	}

	.border-color {
		border: var(--base-px-1) solid #1890ff !important;
	}

	.content {
		background: #f2f4f8;
		min-height: 92%;
		//padding-top: var(--base-px-5);
		padding: var(--base-px-16) var(--base-px-16) 0;

		.hint {
			margin-top: var(--base-px-12) !important;
			padding:  var(--base-px-13);
			background: #f7fbff;
			border: var(--base-px-1) solid #cce9ff;
			font-size:  var(--base-px-13);
			color: #333;
		}

		.button-bottom {
			display: flex;
			align-items: center;
			justify-content: center;
			/* margin-top: var(--base-px-50); */
			position: fixed;
			bottom: var(--base-px-10);
			width: 100%;
			left: 0;
			padding: 0 var(--base-px-10);
		}

		img {
			width: var(--base-px-22);
			height: var(--base-px-22);
		}

		.time {
			margin-bottom: var(--base-px-10) !important;
		}

		.user-item {
			background: #fff;
			position: relative;

			.top-wrapper {
				display: flex;
				-webkit-box-align: center;
				align-items: center;

				.avatar {
					cursor: pointer;
				}

				.name {
					color: rgba(0, 0, 0, .85);
					font-weight: 600;
					align-self: flex-start;
				}
			}
		}
	}
}
</style>
